// QA BUG-34 (Idan) — THE ORDER OF A CAPPED PICKER GRID (CampaignPicker, SourcePicker, WhatsAppTemplatePicker).
// The item that was pre-selected when the grid first became ready (from the URL, the slice or a preselect —
// the caller decides it ONCE per entry) is shown FIRST when it would otherwise sort past the cap, and the
// grid stays capped with «הצג עוד N». It replaces the old rule "the tab-stop target sorts past the cap ⇒
// render the whole list", which opened the grid expanded with no «הצג עוד».
//   · pinned item in `matches` at index >= cap ⇒ [pinned, ...the rest in their natural order];
//   · pinned item already inside the first `cap` ⇒ the natural order, unchanged;
//   · no pinned item in `matches` (none chosen, filtered out by the search, or no longer selectable) ⇒ the
//     first selectable item gets the same treatment, so the collapsed grid always holds a card that can
//     take the roving tab stop (a grid whose every rendered card is tabIndex=-1 traps the keyboard).
// The result depends only on `matches` and the pinned id, never on a click, so a card clicked after
// «הצג עוד» never jumps from under the pointer. Expanded or collapsed, the order is the same.
export const pinnedOrder = <T>(
    matches: T[],
    isPinned: (item: T) => boolean,
    isSelectable: (item: T) => boolean,
    cap: number,
): T[] => {
    let at = matches.findIndex((item) => isPinned(item) && isSelectable(item));
    if (at < 0) at = matches.findIndex(isSelectable);
    return at >= cap ? [matches[at], ...matches.slice(0, at), ...matches.slice(at + 1)] : matches;
};
